window.addRecomToCart = async function(button, variantId) {
  const group = button.closest('.cart-drawer__add-ons');
  const error = group?.querySelector('.cart-add-on-error');
  if (error) { error.hidden = true; error.textContent = ''; }
  button.disabled = true;
  button.classList.add('loading');
  button.setAttribute('aria-busy', 'true');
  let added = false;
  try {
    const drawer = document.querySelector('cart-drawer');
    drawer?.setActiveElement?.(button);
    const sections = drawer?.getSectionsToRender?.().map(section => section.id) || ['cart-drawer', 'cart-icon-bubble'];
    const form = new FormData();
    form.append('id', variantId);
    form.append('quantity', 1);
    form.append('sections', sections.join(','));
    form.append('sections_url', window.location.pathname);
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST', headers: {'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json'}, body: form
    });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error('cart-add-failed');
    added = true;
    if (drawer?.renderContents && sections.every(id => typeof result.sections?.[id] === 'string')) {
      drawer.renderContents(result);
    } else {
      window.location.href = routes.cart_url;
    }
  } catch (failure) {
    if (added) {
      // The item is already in the cart. Recover the view without suggesting
      // a second add, which could create a duplicate line or quantity.
      window.location.href = routes.cart_url;
      return;
    }
    if (error) {
      error.textContent = 'Nie udało się dodać produktu. Spróbuj ponownie lub otwórz kartę produktu.';
      error.hidden = false;
    }
  } finally {
    button.disabled = false;
    button.classList.remove('loading');
    button.removeAttribute('aria-busy');
  }
};
